import axios from 'axios';
import { API_BASE_URL as BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/notifications`;

// 알림 목록 조회 및 모두 읽음 처리
export const getNotifications = async () => {
  const response = await axios.get(API_BASE_URL);
  return response.data;
};

// 읽지 않은 알림 여부 확인
export const checkUnread = async () => {
  const response = await axios.get(`${API_BASE_URL}/check`);
  return response.data;
};

// 알림 단건 삭제
export const deleteNotification = async (notificationId) => {
  await axios.delete(`${API_BASE_URL}/${notificationId}`);
};

// 모든 알림 삭제
export const deleteAllNotifications = async () => {
  await axios.delete(API_BASE_URL);
};